<template lang="pug">
.padding
    h5._300.margin Label

    .box
        v-server-table(
            ref="datatable"
            :url="api"
            :name="tableName"
            :columns="columns"
            :options="options"
        )

            template(slot="outlets" slot-scope="props")
                collection-counter(
                    label="name"
                    :subject="`${trans('general.outlets_assigned')}`"
                    :collection="props.row.outlets"
                )

    label-form(ref="labelForm", @showupStation="showStation($event)")

    div.modal.fade.inactive#station-popup(data-backdrop="true")
      label-outlet-list(
        :label="label"
        title="Apply Label To Station"
        @updateStation="updateStation($event)"
        )

</template>

<script>
import EventBus from '@js/franchise_component/common/event-bus';
import Auth from '@js/plugins/auth';
import labelForm from './label-form.vue';
import eventLabel from './label-event';
import CollectionCounter from '@js/components/collection-counter';

export default {
    components: {
        labelForm,
        CollectionCounter,
    },
    data() {
        let canManageLabel = Auth.hasPermissionTo('franchise_manage_labels');

        let actionButtons = [
            {
                title: 'Create New Label',
                action: () => {
                    this.showLabel(null);
                },
            },
        ];

        if (!canManageLabel) {
            actionButtons = [];
        }

        return {
            label: {},
            tableName: 'VUETABLE_LABEL',
            columns: ['name', 'description', 'outlets'],
            options: {
                checkbox: canManageLabel,
                sortable: ['name'],

                rowClickCallback: row => {
                    this.showLabel(row.id);
                },

                rowClassCallback: () => 'pointer',

                actionButtons: actionButtons,

                checkbox_actions: {
                    api_delete: Laroute.route('franchise.label.delete'),
                    delete_title: 'Delete Label',
                },

                columnsClasses: {
                    name: 'width-30',
                },

                responseAdapter: res => {
                    const data = res.data.data.map(data => {
                        return {
                            id: data.id,
                            name: data.name,
                            description: data.description,
                            outlets: data.outlets,
                            color: data.color,
                        };
                    });

                    return {
                        data,
                        count: res.data.count,
                    };
                },

                templates: {
                    name(h, row) {
                        return require('./label-badge')(h, row);
                    },
                },

                headings: {
                    outlets: this.trans('general.outlets'),
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.label.index');
        },
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        showLabel(id) {
            this.$refs.labelForm.$emit('show-label', id);
        },

        registerEvent() {
            this.$refs.labelForm.$on('label-saved', () => {
                this.$refs.datatable.getData();
            });
        },

        showStation(row) {
            this.label = row;
            $('#station-popup').modal('show');
        },

        updateStation(row) {
            this.label.outlets = row;
            this.$refs.labelForm.$emit('label-updated', this.label.outlets);
        },
    },
};
</script>
<style>
.width-30 {
    width: 30%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/label/label-list.vue